//const DOMAIN = 'http://localhost/';
const DOMAIN = 'https://mycpd.accountingtechniciansireland.ie/';
//const DOMAIN = 'https://sourcecrm.accountingtechniciansireland.ie/';
//const DOMAIN = 'https://sourcestaging.accountingtechniciansireland.ie/';
//const DOMAIN = 'http://116.203.58.81/';
const BASE_URL = `${DOMAIN}CPDCompliance`;
const API_URL = `${BASE_URL}/api`;

export const MYCPD_HOME = `${DOMAIN}/MyCPD/#/Home`;
//export const NELSONCROOM_URL = 'https://acpd.alpha.imago3.com/admLogin.asp';
export const NELSONCROOM_URL = 'https://www.accountingcpd.net/admLogin.asp';
export const Urls = {
  Login: `${BASE_URL}/token`,
  UserDetails: `${API_URL}/account/GetMember?memID=`,
  CourseTypes: `${API_URL}/Lookup/CPDTypes`,
  CourseTypesMyCPD: `${API_URL}/Lookup/CPDTypesForMyCPD`,
  CourseFormats: `${API_URL}/Lookup/CPDFormat`,
  CourseHosts: `${API_URL}/Lookup/LoadCPDHost`,
  CourseLocations: `${API_URL}/Lookup/Location`,
  SubmitFeedback: `${BASE_URL}/api/contact/SendInfo`,
  FaceToFace_URL: `${API_URL}/faceToface`,
  AddRecord: `${API_URL}/Workflow/add`,
  UploadRecordImage: `${API_URL}/Workflow/file/upload`,
  CPDRecord_Info_URL: `${API_URL}/Member/GetMemberCPD`,
  Member_Info_URL: `${API_URL}/account/GetMember?memID=`,
  Types_URL: `${API_URL}/Lookup/CPDTypesForMyCPD`,
  Formats_URL: `${API_URL}/Lookup/CPDFormat`,
  Hosts_URL: `${API_URL}/Lookup/LoadCPDHost`,
  Locations_URL: `${API_URL}/Lookup/Location`,
  Courses_URL: `${API_URL}/Lookup/GetCourses`,
  Course_Detail_URL: `${API_URL}/Lookup/GetCourse`,
  ADD_Record_URL: `${API_URL}/Workflow/add`,
  File_Upload_URL: `${API_URL}/Workflow/file/upload`,
  FACE_TO_FACE_Excel_Download_URL: `${API_URL}/faceToface/Excel`,
  Approved_CPD_URL: `${API_URL}/approvedcpd`,
  Excel_Approved_Download_URL: `${API_URL}/approvedcpd/Excel`,
  CPDTypes_URL: `${API_URL}/Lookup/CPDTypes`,
  Library_URL: `${API_URL}/Library`,
  LibraryExcel_Download_URL: `${API_URL}/Library/Excel`,
  Accounting_Login_URL: `${API_URL}/CPDgo/CPDGOLog?action=accountingcpd&isBrowser=true`,
  Knowledge_Login_URL: `${API_URL}/CPDgo/CPDGOLog?action=KnowledgePoint&isBrowser=true`,
  Ethics_Login_URL: `${API_URL}/CPDgo/CPDGOLog?action=ProfessionalEthics&isBrowser=true`,
  SignOut_URL: `${API_URL}/account/LogOff`,
  Video: `${BASE_URL}/MyCPDMultimedia/CodeofProfessionalEthics2019.mp4`,
  SavePauseTime: `${API_URL}/CPDgo/SavePauseVideoTime`,
  GetPauseVideoTime: `${API_URL}/CPDgo/GetPauseVideoTime`,
  WorkflowUpdate: `${API_URL}/Workflow/Update`,
  Listing_URL: `${API_URL}/Member/GetMemberCPD`,
  Hours_URL: `${API_URL}/Member/MemberCPDHours`,
  Delete_Record_URL: `${API_URL}//Workflow/DeleteMemberCPD`,
  MyCPDReport_URL: `${API_URL}/Member/PDF`,
  CPDgo_URL: `${API_URL}/CPDgo`,
};

let url = `${DOMAIN}/CPDCompliance/`;
let baseURL = url + 'api/';

export let AdminUrls = {
  ADMIN: {
    CPDAUDIT: baseURL + 'CPDAudit',
    CPDADMIN: baseURL + 'Library',
    CPDADMINADDCOURSE: baseURL + 'Library/Add',
    CPDADMINUPDATECOURSE: baseURL + 'Library/Update',
    CPDREPORT: baseURL + 'CPDAccredited',
    CPDMEMBER: baseURL + 'member/GetMemberCPDAll',
    CPDACCREDITED: baseURL + 'approvedcpdq',
    CPDACCREDITEDAR: baseURL + 'approvedcpdq/CPDUpdate',
    CPDACCRDFDOWNLOAD: baseURL + 'approvedcpdq/file/download',
    CPDRANDCOMPLAIANCEREPORT: baseURL + 'report/ReportRandomCompliantCPD',
    CPDINDIVIDUALREPORT: baseURL + 'report/ReportIndividualMemberCPD',
    CPDCOMPLAIANCEREPORT: baseURL + 'report/ReportCompliantMembersCPD',
    REPORTDOWNLOAD: baseURL + 'report/file/download',
    INDIVIDUALUSEREXCEL: baseURL + 'report/IndividualUserExcel',
    COMPLIANTEXCEL: baseURL + 'report/CompliantExcel',
    RANDOMCOMPLIANTEXCEL: baseURL + 'report/RandomCompliantExcel',
    CPDCOMPLIANTINFO: baseURL + 'report/CPDCompliantInfo',
    REPORTUSERLOGININFO: baseURL + 'report/ReportUserLoginInfo',
    USERLOGININFOEXCEL: baseURL + 'report/UserLoginInfoExcel',
    LOG: baseURL + 'log',
    GETHOST: baseURL + 'Lookup/getCPDHost',
    UPDATEHOST: baseURL + 'Lookup/updateHost',
    NUMBEROFCPDQUEUE: baseURL + 'approvedcpdq/NumberOfCPDQueue',
    GETUSERDETAILS: baseURL + 'UserManagement/GetUserDetails',
    UPDATEEXTERNALUSER: baseURL + 'UserManagement/UpdateExternalUser',
    RECORDEDZEROHOUR: baseURL + 'report/RecordedZeroHour',
    RECORDEDZEROHOUREXCEL: baseURL + 'report/RecordedZeroHourExcel',
    UPDATELOCKEDSTATUS: baseURL + 'report/UpdateLockedStatus',
    FILEUPLOAD: baseURL + 'bulkupload/file/upload',
    COURSEFILE: baseURL + 'CourseFile/file/upload',
    DELETECOURSE: baseURL + 'CourseFile/DeleteCourse',
    SENDEMAIL: baseURL + 'contact/ContactMember',
    GETCPDYEARS: baseURL + 'systemsetting/GetCPDYears',
    CPDQUEUEUPDATE: baseURL + 'approvedcpdq/CPDQueueUpdate',

    VIDEOACCESSFILEUPLOAD: baseURL + 'VideoAccessBulkUpload/file/upload',
    REPORTINDIVIDUALAFFILIATECPD:
      baseURL + 'affiliatereport/ReportIndividualAffiliateCPD',
    INDIVIDUALAFFILIATEEXCEL:
      baseURL + 'affiliatereport/IndividualAffiliateExcel',
    SAMPLE_EXCELFILE: url + 'Content/SampleExcelFile/CPDHoursBulkUpload.xlsx',
  },
  USER: {
    FACETOFACE: baseURL + 'faceToface',
    MYCPD: baseURL + 'MyCPD',
    CPDRECORD: baseURL + 'CPDURecord',
    CPDLIBRARY: baseURL + 'Library',
    CPDGO: baseURL + 'CPDgo',
    APPROVEDCPD: baseURL + 'approvedcpd',
    MEMBERCPD: baseURL + 'Member/GetMemberCPD',
    MEMBERCPDHOURS: baseURL + 'Member/MemberCPDHours',
    DELETEMEMBERCPD: baseURL + 'Workflow/DeleteMemberCPD',
    GETMEMBERINFO: baseURL + 'account/GetMember',
    WORKFLOWADD: baseURL + 'Workflow/add',
    WORKFLOWUPDATE: baseURL + 'Workflow/Update',
    FILEUPLOAD: baseURL + 'Workflow/file/upload',
    MEMBERCOMPLETEDCPDHOURS: baseURL + 'Member/CPDCourseHours',
    SHOWDECLARE: baseURL + 'Member/ShowDeclare',
    DECLARECPD: baseURL + 'Workflow/DeclareCPD',
    FACETOEXCEL: baseURL + 'faceToface/Excel',
    APPROVEDCPDEXCEL: baseURL + 'approvedcpd/Excel',
    CPDTYPE: baseURL + 'Lookup/CPDTypesForMyCPD',
    SHOWDECLAREGRACEPERIOD: baseURL + 'Member/ShowDeclareGracePeriod',
    CPDGOLOG: baseURL + 'CPDgo/CPDGOLog',
    GETPAUSEVIDEOTIME: baseURL + 'CPDgo/GetPauseVideoTime',
    SAVEPAUSEVIDEOTIME: baseURL + 'CPDgo/SavePauseVideoTime',
  },

  EXTUSER: {
    CPDACCREDITEADD: baseURL + 'approvedcpdq/CPDAdd',
    CPDACCREDITEUPDATE: baseURL + 'approvedcpdq/CPDURecord',
    FILEUPLOAD: baseURL + 'approvedcpdq/file/upload',
  },

  COMMON: {
    HOME: baseURL + 'member/CPDHome',
    CPDTYPE: baseURL + 'Lookup/CPDTypes',
    CONTACTUS: baseURL + 'contact',
    LOCATION: baseURL + 'Lookup/CPDLocation',
    HOST: baseURL + 'Lookup/CPDHost',
    CPDTYPES: baseURL + 'Lookup/CPDTypesearch',
    GETCOURSEBYID: baseURL + 'Lookup/GetCourse',
    GETCOURSESBYCPDTYPE: baseURL + 'Lookup/GetCourses',
    CPDLIBRARYEXCEL: baseURL + 'Library/Excel',
    CPDMEMBERPDF: baseURL + 'Member/PDF',
    GETTEMPID: baseURL + 'Account/GetTempId',
    CPDFORMAT: baseURL + 'Lookup/CPDFormat',
    COURSELOCATION: baseURL + 'Lookup/Location',
    LOADHOST: baseURL + 'Lookup/LoadCPDHost',
    GETEMPLOYERLIST: baseURL + 'Lookup/GetEmployerList',
    DOWNLOADPDF: baseURL + 'Member/DownloadPDF',
    GETCOURSEFILE: baseURL + 'CourseFile/GetCourseFile',
    COURSEFILEDOWNLOAD: baseURL + 'CourseFile/file/download',
    VIDEOFILE: url + 'Content/AdminCourseFiles/',
    GETREPORTLIST: baseURL + 'reportlookup/GetReportList',
    GETCPDQUEUECOMMENTS: baseURL + 'approvedcpdq/GetCPDQueueComments',
  },

  AUTH: {
    LOGIN: baseURL + 'Token',
    REGISTER: baseURL + 'Account/Register',
    ACCESSTOKEN: baseURL + 'Account/ObtainLocalAccessToken',
  },
  SETTINGS: {
    CPDHOURS: 15,
    SERVICEBASE: url,
    // EXTERNALURL: atiURL,
  },
};
